import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import IncidentForm from "./IncidentForm";
import { CustomComponentProps } from "utils/types/generalTypes";

export type IncidentFormGroupProps = CustomComponentProps;

const IncidentFormGroup = ({ className, style }: IncidentFormGroupProps) => {
    const incidentGroup = useSelector(
        (state: RootState) => state.incidentForm.incidentGroup
    );

    return (
        <div
            className="control"
            id={`incident-modal-body ${className}`}
            style={style}
        >
            <form id="incident-form" encType="multipart/form-data">
                {incidentGroup.map((i) => (
                    <IncidentForm incidentId={i.id} incident={i} key={i.id} />
                ))}
            </form>
        </div>
    );
};

export default IncidentFormGroup;
